import { CacheUtils } from '@common/utils';
import { useEffect } from 'react';

/**
 * Periodically prune expired cache items.
 * Note: this will only work for items that have been cached via CacheUtils.set()
 */
const maxCacheAgeMs = 24 * 60 * 60 * 1000; // 24 hours;

export const useCache = () => {
  useEffect(() => {
    const cachePruningInterval = setInterval(
      async () => await CacheUtils.evictExpiredKeys(maxCacheAgeMs),
      300 * 1000, // every five minutes
    );
    return () => {
      clearInterval(cachePruningInterval);
    };
  }, []);
};
